import Vue from 'vue'

const STORAGE_KEY = 'jiangk-admin-locale'
const PREFERENCE_KEY = 'jiangk-admin-locale-preference'

export const supportedAdminLocales = ['zh-Hans', 'zh-Hant', 'en']

function systemLocale() {
  const language = String(window.navigator.language || '').toLowerCase()
  if (language.startsWith('zh-') && !/^zh-(cn|sg|hans)/.test(language)) return 'zh-Hant'
  if (language.startsWith('zh')) return 'zh-Hans'
  if (language.startsWith('en')) return 'en'
  return 'zh-Hans'
}

// Keep old explicit selections compatible, but do not turn a fresh automatic
// detection into a permanent selection on the next page load.
const storedPreference = window.localStorage.getItem(PREFERENCE_KEY)
const legacyLocale = window.localStorage.getItem(STORAGE_KEY)
const initialPreference = ['system', ...supportedAdminLocales].includes(storedPreference) ? storedPreference
  : supportedAdminLocales.includes(legacyLocale) ? legacyLocale : 'system'
export const adminLocaleState = Vue.observable({ preference: initialPreference, locale: initialPreference === 'system' ? systemLocale() : initialPreference })

const messages = {
  'zh-Hans': {
    language: '语言',
    appearance: '外观',
    followSystem: '跟随系统',
    lightMode: '浅色',
    darkMode: '深色',
    simplifiedChinese: '简体中文',
    traditionalChinese: '繁體中文',
    english: 'English',
    brandName: '桨刻体育',
    slogan: '让每一位龙舟运动员\n被看见',
    intro: '赛事管理 · 报名审核 · 运动员档案 · 成绩积分\n一站式龙舟赛事数据资产平台',
    contact: '试用请致电：86-13168677659',
    pointWorkflow: '赛事全流程管理',
    pointAthletes: '运动员注册与档案',
    pointRanking: '三种模式积分排名',
    loginTitle: '管理平台登录',
    loginDesc: '赛事管理 · 报名审核 · 成绩积分',
    username: '用户名',
    password: '密码',
    captcha: '验证码',
    captchaAlt: '点击刷新验证码',
    login: '登录',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    captchaRequired: '请输入验证码',
    loginSuccess: '登录成功',
    returnToOfficialWebsite: '返回桨刻体育官网',
    platformFooter: '桨刻体育 · 龙舟赛事数据资产平台',
    adminBackend: '桨刻管理后台',
    unnamed: '未命名',
    todoAndNotice: '待办与通知',
    refresh: '刷新',
    authPending: '实名认证待审 {count} 条',
    cancelPending: '注销账号待审 {count} 条',
    registrationPending: '报名申请待审 {count} 条',
    teamPending: '俱乐部入驻待审 {count} 家',
    nothingPending: '暂无待办，一切正常',
    newEvents: '新赛事',
    noEvents: '暂无赛事',
    administrator: '管理员',
    logout: '退出登录',
    eventWorkbench: '赛事工作台',
    contentLanguage: '内容语言',
    primaryLanguage: '主语言',
    publishedLanguages: '对外发布语言',
    publishedLanguagesTip: 'H5 只展示已完成并勾选发布的语言。简体中文为默认主语言。',
    generateTraditional: '从简体生成繁体',
    generatedTraditional: '已生成繁体草稿，请检查专有名词后再发布',
    translationManualEnglish: '英文赛事名称、地点及说明需填写官方译名；翻译服务接入后可在这里生成草稿。',
    sourceLanguage: '主语言',
    translationReady: '内容已填写',
    translationMissing: '尚未完成',
    eventTitle: '赛事标题',
    eventSubtitle: '赛事副标题',
    eventType: '赛事类型',
    eventLocation: '赛事地点',
    eventDescription: '赛事说明',
    roundName: '场次名称', roundDescription: '场次说明',
    categoryName: '组别名称',
    stageName: '阶段名称', stageNameRequired: '请输入阶段名称', stageConfig: '阶段配置',
    stageType: '阶段类型', stageAdd: '新增阶段', stageEdit: '编辑阶段', stageSaved: '阶段保存成功',
    stageSort: '排序', stageStatus: '状态', stageEnabled: '启用', stageDisabled: '停用',
    stageActions: '操作', stageDelete: '删除', stageDeleteConfirm: '确定删除此阶段吗？', stageOther: '其他',
    categoryDescription: '组别说明',
    requiredPublishedTitle: '请先填写所选发布语言的赛事标题',
    requiredPublishedLocation: '请先填写所选发布语言的赛事地点',
    requiredPublishedCategory: '请先填写所选发布语言的组别名称'
  },
  'zh-Hant': {
    language: '語言',
    appearance: '外觀',
    followSystem: '跟隨系統',
    lightMode: '淺色',
    darkMode: '深色',
    simplifiedChinese: '简体中文',
    traditionalChinese: '繁體中文',
    english: 'English',
    brandName: '槳刻體育',
    slogan: '讓每一位龍舟運動員\n被看見',
    intro: '賽事管理 · 報名審核 · 運動員檔案 · 成績積分\n一站式龍舟賽事數據資產平台',
    contact: '試用請致電：86-13168677659',
    pointWorkflow: '賽事全流程管理',
    pointAthletes: '運動員註冊與檔案',
    pointRanking: '三種模式積分排名',
    loginTitle: '管理平台登入',
    loginDesc: '賽事管理 · 報名審核 · 成績積分',
    username: '使用者名稱',
    password: '密碼',
    captcha: '驗證碼',
    captchaAlt: '點擊重新載入驗證碼',
    login: '登入',
    usernameRequired: '請輸入使用者名稱',
    passwordRequired: '請輸入密碼',
    captchaRequired: '請輸入驗證碼',
    loginSuccess: '登入成功',
    returnToOfficialWebsite: '返回槳刻體育官網',
    platformFooter: '槳刻體育 · 龍舟賽事數據資產平台',
    adminBackend: '槳刻管理後台',
    unnamed: '未命名',
    todoAndNotice: '待辦與通知',
    refresh: '重新整理',
    authPending: '實名認證待審 {count} 筆',
    cancelPending: '帳號註銷待審 {count} 筆',
    registrationPending: '報名申請待審 {count} 筆',
    teamPending: '俱樂部入駐待審 {count} 家',
    nothingPending: '暫無待辦，一切正常',
    newEvents: '新賽事',
    noEvents: '暫無賽事',
    administrator: '管理員',
    logout: '登出',
    eventWorkbench: '賽事工作台',
    contentLanguage: '內容語言',
    primaryLanguage: '主語言',
    publishedLanguages: '對外發布語言',
    publishedLanguagesTip: 'H5 只展示已完成並勾選發布的語言。簡體中文為預設主語言。',
    generateTraditional: '由簡體產生繁體',
    generatedTraditional: '已產生繁體草稿，請檢查專有名詞後再發布',
    translationManualEnglish: '英文賽事名稱、地點及說明需填寫官方譯名；翻譯服務接入後可在此產生草稿。',
    sourceLanguage: '主語言',
    translationReady: '內容已填寫',
    translationMissing: '尚未完成',
    eventTitle: '賽事標題',
    eventSubtitle: '賽事副標題',
    eventType: '賽事類型',
    eventLocation: '賽事地點',
    eventDescription: '賽事說明',
    roundName: '場次名稱', roundDescription: '場次說明',
    categoryName: '組別名稱',
    stageName: '階段名稱', stageNameRequired: '請輸入階段名稱', stageConfig: '階段配置',
    stageType: '階段類型', stageAdd: '新增階段', stageEdit: '編輯階段', stageSaved: '階段儲存成功',
    stageSort: '排序', stageStatus: '狀態', stageEnabled: '啟用', stageDisabled: '停用',
    stageActions: '操作', stageDelete: '刪除', stageDeleteConfirm: '確定刪除此階段嗎？', stageOther: '其他',
    categoryDescription: '組別說明',
    requiredPublishedTitle: '請先填寫所選發布語言的賽事標題',
    requiredPublishedLocation: '請先填寫所選發布語言的賽事地點',
    requiredPublishedCategory: '請先填寫所選發布語言的組別名稱'
  },
  en: {
    language: 'Language',
    appearance: 'Appearance',
    followSystem: 'System',
    lightMode: 'Light',
    darkMode: 'Dark',
    simplifiedChinese: 'Simplified Chinese',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    brandName: 'JiangK Sports',
    slogan: 'Let every dragon boat athlete\nbe seen',
    intro: 'Event operations · Registration review · Athlete profiles · Results and ranking\nOne platform for dragon boat event data',
    contact: 'For a trial, call: +86 131 6867 7659',
    pointWorkflow: 'End-to-end event operations',
    pointAthletes: 'Athlete registration and profiles',
    pointRanking: 'Three ranking modes',
    loginTitle: 'Management sign in',
    loginDesc: 'Events · Registration · Results',
    username: 'Username',
    password: 'Password',
    captcha: 'Verification code',
    captchaAlt: 'Click to refresh verification code',
    login: 'Sign in',
    usernameRequired: 'Enter your username',
    passwordRequired: 'Enter your password',
    captchaRequired: 'Enter the verification code',
    loginSuccess: 'Signed in',
    returnToOfficialWebsite: 'Return to the JiangK Sports website',
    platformFooter: 'JiangK Sports · Dragon Boat Event Data Platform',
    adminBackend: 'JiangK Management',
    unnamed: 'Unnamed',
    todoAndNotice: 'Tasks and notifications',
    refresh: 'Refresh',
    authPending: '{count} identity reviews pending',
    cancelPending: '{count} account closures pending',
    registrationPending: '{count} registrations pending',
    teamPending: '{count} club applications pending',
    nothingPending: 'No pending tasks',
    newEvents: 'New events',
    noEvents: 'No events',
    administrator: 'Administrator',
    logout: 'Sign out',
    eventWorkbench: 'Event workbench',
    contentLanguage: 'Content language',
    primaryLanguage: 'Primary language',
    publishedLanguages: 'Public languages',
    publishedLanguagesTip: 'The public H5 only offers completed and selected languages. Simplified Chinese is the default primary language.',
    generateTraditional: 'Generate Traditional Chinese',
    generatedTraditional: 'Traditional Chinese draft generated. Review proper nouns before publishing.',
    translationManualEnglish: 'Use official English names for the event and venue. Machine translation drafts will be available after a provider is configured.',
    sourceLanguage: 'Primary',
    translationReady: 'Content complete',
    translationMissing: 'Incomplete',
    eventTitle: 'Event title',
    eventSubtitle: 'Subtitle',
    eventType: 'Event type',
    eventLocation: 'Venue',
    eventDescription: 'Description',
    roundName: 'Race name', roundDescription: 'Race notes',
    categoryName: 'Category name',
    stageName: 'Stage name', stageNameRequired: 'Enter a stage name', stageConfig: 'Stages',
    stageType: 'Stage type', stageAdd: 'Add stage', stageEdit: 'Edit stage', stageSaved: 'Stage saved',
    stageSort: 'Order', stageStatus: 'Status', stageEnabled: 'Enabled', stageDisabled: 'Disabled',
    stageActions: 'Actions', stageDelete: 'Delete', stageDeleteConfirm: 'Delete this stage?', stageOther: 'Other',
    categoryDescription: 'Category description',
    requiredPublishedTitle: 'Complete the event title in every selected public language',
    requiredPublishedLocation: 'Complete the venue in every selected public language',
    requiredPublishedCategory: 'Complete the category name in every selected public language'
  }
}

const routeTitles = {
  '语言管理': { 'zh-Hant': '語言管理', en: 'Languages' },
  '回收站': { 'zh-Hant': '回收站', en: 'Recycle bin' },
  '首页': { 'zh-Hant': '首頁', en: 'Dashboard' },
  '仪表盘': { 'zh-Hant': '儀表板', en: 'Dashboard' },
  '赛事管理': { 'zh-Hant': '賽事管理', en: 'Events' },
  '赛事工作台': { 'zh-Hant': '賽事工作台', en: 'Event workbench' },
  '运动员管理': { 'zh-Hant': '運動員管理', en: 'Athletes' },
  '队伍管理': { 'zh-Hant': '隊伍管理', en: 'Teams' },
  '报名管理': { 'zh-Hant': '報名管理', en: 'Registrations' },
  '报名审核': { 'zh-Hant': '報名審核', en: 'Registration review' },
  '成绩管理': { 'zh-Hant': '成績管理', en: 'Results' },
  '赛事成绩': { 'zh-Hant': '賽事成績', en: 'Results' },
  '积分管理': { 'zh-Hant': '積分管理', en: 'Scoring' },
  '公告管理': { 'zh-Hant': '公告管理', en: 'Notices' },
  '系统管理': { 'zh-Hant': '系統管理', en: 'System' },
  '用户管理': { 'zh-Hant': '使用者管理', en: 'Users' },
  '角色管理': { 'zh-Hant': '角色管理', en: 'Roles' },
  '菜单管理': { 'zh-Hant': '選單管理', en: 'Menus' },
  '字典管理': { 'zh-Hant': '字典管理', en: 'Dictionaries' },
  '操作日志': { 'zh-Hant': '操作日誌', en: 'Audit log' }
}

export function setAdminLocale(locale) {
  adminLocaleState.preference = ['system', ...supportedAdminLocales].includes(locale) ? locale : 'system'
  window.localStorage.setItem(PREFERENCE_KEY, adminLocaleState.preference)
  applyAdminLocale()
}

function applyAdminLocale() {
  const next = adminLocaleState.preference === 'system' ? systemLocale() : adminLocaleState.preference
  adminLocaleState.locale = next
  window.localStorage.setItem(STORAGE_KEY, next)
  document.documentElement.lang = next
  document.documentElement.dataset.adminLocale = next
  window.dispatchEvent(new CustomEvent('jiangk-admin-locale-change', { detail: next }))
}

export function t(key, params = {}) {
  const dictionary = messages[adminLocaleState.locale] || messages['zh-Hans']
  let value = dictionary[key] || messages['zh-Hans'][key] || key
  Object.keys(params).forEach(name => {
    value = value.replace(new RegExp(`\\{${name}\\}`, 'g'), params[name])
  })
  return value
}

export function translateRouteTitle(title) {
  if (!title || adminLocaleState.locale === 'zh-Hans') return title
  const translated = routeTitles[title]
  return translated ? (translated[adminLocaleState.locale] || title) : title
}

export function adminLocaleOptions() {
  return supportedAdminLocales.map(value => ({
    value,
    label: t(value === 'zh-Hans' ? 'simplifiedChinese' : value === 'zh-Hant' ? 'traditionalChinese' : 'english')
  }))
}

window.addEventListener('languagechange', () => {
  if (adminLocaleState.preference === 'system') applyAdminLocale()
})
setAdminLocale(initialPreference)
